/* Ease Cushion landing page — shared behaviour
   Loaded once via the "Ease – Header" section (with defer). Safe to include
   more than once (guarded by window.__easeCushionInit).

   CHANGELOG
   - [CRO Oct 2026] Add to cart now checks the response. Before, a refused add
     (sold out, invalid variant) still showed "Added ✓".
   - [CRO Oct 2026] After a successful add the customer goes to the cart.
     Before, the button said "Added ✓" and nothing else happened, so there was
     no path to checkout. Products with sizes never reach this code: the size
     guard in "Ease – Header" sends them to the product page first.
   - [CRO Oct 2026] A button that is already adding ignores repeat taps.
*/
(function () {
  'use strict';
  if (window.__easeCushionInit) return;
  window.__easeCushionInit = true;

  /* ---- Layer explorer: pick a layer, the cross-section responds ---- */
  function initLayers() {
    var picks = document.querySelectorAll('[data-pick]');
    var plates = document.querySelectorAll('[data-layer]');
    if (!picks.length || !plates.length) return;

    function select(id) {
      picks.forEach(function (b) { b.setAttribute('aria-selected', b.dataset.pick === id ? 'true' : 'false'); });
      plates.forEach(function (p) {
        var on = p.dataset.layer === id;
        p.classList.toggle('is-on', on);
        p.classList.toggle('is-dim', !on);
      });
    }
    picks.forEach(function (b) {
      b.addEventListener('click', function () { select(b.dataset.pick); });
      b.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft' && e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        e.preventDefault();
        var list = Array.prototype.slice.call(picks);
        var i = list.indexOf(b);
        var next = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? (i + 1) % list.length
                                                                      : (i - 1 + list.length) % list.length;
        list[next].focus(); select(list[next].dataset.pick);
      });
    });
    var initial = document.querySelector('[data-pick][aria-selected="true"]');
    select(initial ? initial.dataset.pick : '1');
  }

  /* ---- Desktop rail: show once the hero offer card has scrolled past ---- */
  function initRail() {
    var rail = document.getElementById('ecRail');
    var anchor = document.querySelector('.ec-hero__act');
    if (!rail || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var past = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      rail.classList.toggle('is-on', past);
      rail.setAttribute('aria-hidden', past ? 'false' : 'true');
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---- Real Shopify "Add to cart" buttons: [data-ease-add-to-cart] ---- */
  function initAddToCart() {
    var buttons = document.querySelectorAll('[data-ease-add-to-cart]');
    if (!buttons.length) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return; /* no product picked: let it behave as a normal anchor link */
        e.preventDefault();
        if (btn.getAttribute('aria-busy') === 'true') return; /* already adding */

        var original = btn.textContent;
        var cartUrl = btn.getAttribute('data-fallback-href') || (root + 'cart');
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = 'Adding…';

        function reset() {
          btn.textContent = original;
          btn.removeAttribute('aria-busy');
        }

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        })
          .then(function (res) {
            return res.json().catch(function () { return {}; }).then(function (body) {
              if (!res.ok) throw body;
              return body;
            });
          })
          .then(function () {
            btn.textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            window.setTimeout(function () { window.location.href = cartUrl; }, 500);
          })
          .catch(function (err) {
            /* refused (e.g. sold out) or network error */
            var msg = err && (err.description || err.message);
            btn.textContent = msg ? String(msg).slice(0, 60) : 'Could not add, try again';
            window.setTimeout(reset, 2600);
          });
      });
    });
  }

  function boot() {
    initLayers();
    initRail();
    initAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();